import log from 'loglevel';
import React, { createContext, useContext, useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { StateChangedEvents } from '../../sdk/PlayerEvents';
import {
  Events,
  State,
  NotificationAction,
  ShortcutAction,
} from '../../types/player';
import ControlButton from '../ui/ControlButton';
import Shortcuts from '../../utils/Shortcut';

const Play = () => {
  const { sdk } = usePlayerContext();

  const [playerState, setPlayerState] = useState(
    sdk.getCurrentState() as string,
  );

  useEffect(() => {
    sdk.on(Events.STATE_CHANGED, (event: StateChangedEvents) => {
      log.debug('playerState FROM PLAY', 'State changed', event);
      if (![State.PLAYING, State.PAUSED].includes(event.newState)) return;
      setPlayerState(event.newState);
    });
  }, []);

  function play() {
    sdk.play();
  }

  function pause() {
    sdk.pause();
  }

  function togglePlayKeybord() {
    if (playerState === State.PLAYING) {
      sdk.notificationAction(NotificationAction.PAUSE);
      pause();
    } else {
      sdk.notificationAction(NotificationAction.PLAY);
      play();
    }
  }
  let short = sdk.options().getShortCut(ShortcutAction.PLAY);
  if (short) {
    Shortcuts([
      {
        key: short.key ?? '',
        action: togglePlayKeybord,
        altKey: short.altKey,
        shiftKey: short.shiftKey,
        ctrlKey: short.ctrlKey,
      },
    ]);
  }

  log.debug('playerState', playerState);
  return (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control ${sdk.getClassNamePrefix()}-player-control-play`}
    >
      {playerState === State.PLAYING ? (
        <ControlButton
          className={'pause'}
          icon={'circlePause'}
          handleAction={pause}
          title={'Pause'}
        />
      ) : (
        <ControlButton
          className={'play'}
          icon={'play'}
          handleAction={play}
          title={'Play'}
        />
      )}
    </div>
  );
};

export default Play;
